import { httpRequest } from "@/utils/HttpRequest";
import { IPage } from "@/types/AppTypes";
import { ISCMAssetsReturnSearch, ISCMAssetsReturnDetail, ISCMAssetsReturnStatistics, ISCMAssetsReturnInsert, ISCMAssetsReturnUpdate, ISCMSDcGoodsOne, ISCMSDcSearch, ISCMORVRMTransferSearch, ISCMORVRMTransferDetails } from "./assetsReturnTypes";


export interface ISCMPage<T, S> extends IPage<T> {
    statistics: S
}


export interface IFmsShopUnitDetail {
    address: string,
    bentity: string,
    branch: string,
    branchList: string,
    code: string,
    contact: string,
    createTime: string,
    createUser: string,
    deleteFlag: string,
    enable: string,
    id: string,
    name: string,
    note: string,
    phone: string,
    shop: string,
    shopCode: string,
    shopList: string,
    shopName: string,
    status: string,
    tel: string,
    updateTime: string,
    updateUser: string,
    ver: string,
}

class AssetsReturnService {
    async page(searchVo: ISCMAssetsReturnSearch) {
        const apiUrl = "/assets/assets/page";
        return await httpRequest.post<IPage<ISCMAssetsReturnDetail>>(apiUrl, searchVo);
    }
    async pageStatistics(searchVo: ISCMAssetsReturnSearch) {
        const apiUrl = "/assets/assets/total";
        return await httpRequest.post<ISCMAssetsReturnStatistics>(apiUrl, searchVo);
    }
    async one(id: string) {
        const apiUrl = `/assets/assets/findById/${id}`
        return await httpRequest.get<ISCMAssetsReturnDetail>(apiUrl)
    }
    async insert(insertVo: ISCMAssetsReturnInsert) {
        const apiUrl = '/assets/assets/insert'
        return await httpRequest.post<boolean>(apiUrl, insertVo)
    }
    async update(updateVo: ISCMAssetsReturnInsert) {
        const apiUrl = '/assets/assets/update'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async export(searchVo: ISCMAssetsReturnSearch) {
        const apiUrl = "/assets/assets/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: 300000 });
    }

    async print(id: string) {
        const apiUrl = `/assets/assets/print/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }

    //资产明细查询接口
    async assetsListDetails(searchVo: ISCMORVRMTransferSearch) {
        const apiUrl = "/assets/assets/detailsPage";
        return await httpRequest.post<IPage<ISCMORVRMTransferDetails>>(apiUrl, searchVo);
    }
}

export const assetsReturnService = new AssetsReturnService();